<template>
  <div class="container ms-0 ps-0">
    <div class="card w-100 mb-3">
      <div class="card-header">
        <h5 class="my-2">Loading Form</h5>
      </div>
      <article class="card-body">
        <div class="flex-grow-1">
          <div class="row">
            <div class="col-4">
              <div class="placeholder-glow"><span class="placeholder w-100 input"></span></div>
            </div>
            <div class="col-4">
              <div class="placeholder-glow"><span class="placeholder w-100 input"></span></div>
            </div>
            <div class="col-4">
              <div class="placeholder-glow"><span class="placeholder w-100 input"></span></div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="placeholder-glow"><span class="placeholder w-100 input"></span></div>
            </div>
            <div class="col-6">
              <div class="placeholder-glow"><span class="placeholder w-100 input"></span></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="placeholder-glow"><span class="placeholder w-100 input"></span></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="placeholder-glow"><span class="placeholder w-100 txtarea"></span></div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="d-flex w-100 placeholder-glow">
              <BootstrapButton name="submit" class="me-2 placeholder"> Save </BootstrapButton>
              <BootstrapButton name="cancel" variant="secondary" class="placeholder">
                Cancel
              </BootstrapButton>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.txtarea {
  height: 100px;
}

.input {
  height: 25px;
}
</style>
